import * as React from 'react'

import {
  BaseRequestItem,
  RequestComponentProps,
} from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'

const Request = ({ request, index, compact }: RequestComponentProps) => {
  return (
    <BaseRequestItem
      request={request}
      index={index}
      compact={compact}
      {...(request.actionUrl && { url: request.actionUrl })}
      {...(request.remoteUrl && { remoteUrl: request.remoteUrl })}
    />
  )
}

export default Request
